import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import StudentAdjustmentForm from 'containers/AdditionalAdjustments/Form/StudentAdjustmentForm';
import { Search as SearchInput } from 'UI/Inputs';
import { getActiveSchool } from 'helpers/localstorage';
import { searchStudents } from 'actions/search';
import { DataList } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { Checkbox } from '@haldor/ui';

var AssignAdditionalAdjustments = /*#__PURE__*/function (_Component) {
  _inherits(AssignAdditionalAdjustments, _Component);

  var _super = _createSuper(AssignAdditionalAdjustments);

  function AssignAdditionalAdjustments(props) {
    var _this;

    _classCallCheck(this, AssignAdditionalAdjustments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
      var onClose = _this.props.onClose;
      return new Promise(function (resolve) {});
    });

    _defineProperty(_assertThisInitialized(_this), "runSearch", function (term) {
      if (term != null && term !== '') {
        _this.setState({
          term: term
        });

        Promise.all([_this.props.searchStudents(term)]).then(function () {
          _this.setState({
            loading: false,
            selectStudent: null
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (value) {
      _this.runSearch(value.query);
    });

    _defineProperty(_assertThisInitialized(_this), "selectStudent", function (student) {
      var _this$state$selectStu;

      if (((_this$state$selectStu = _this.state.selectStudent) === null || _this$state$selectStu === void 0 ? void 0 : _this$state$selectStu.userId) == student.userId) {
        _this.setState({
          selectStudent: null
        });
      } else {
        _this.setState({
          selectStudent: student
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudent", function (user) {
      var _this$state$selectStu2, _this$state$selectStu3;

      return /*#__PURE__*/React.createElement(RowItem, {
        key: user.userId
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: ((_this$state$selectStu2 = _this.state.selectStudent) === null || _this$state$selectStu2 === void 0 ? void 0 : _this$state$selectStu2.userId) == user.userId,
        onChange: function onChange() {
          return _this.selectStudent(user);
        },
        label: user.displayName,
        disabled: _this.state.selectStudent != null && ((_this$state$selectStu3 = _this.state.selectStudent) === null || _this$state$selectStu3 === void 0 ? void 0 : _this$state$selectStu3.userId) != user.userId
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: _this.props.translate('search-student'),
        onSubmit: _this.onSearch,
        lengthLimit: 3,
        autofocus: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('students'),
        data: _this.props.students,
        renderRow: _this.renderStudent,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      })), _this.state.selectStudent != null ? /*#__PURE__*/React.createElement(StudentAdjustmentForm, {
        onSubmit: _this.onSubmit,
        onClose: _this.props.onClose,
        userId: _this.state.selectStudent.userId
      }) : null);
    });

    _this.state = {
      selectStudent: null
    };
    _this.selectStudent = _this.selectStudent.bind(_assertThisInitialized(_this));
    _this.renderStudent = _this.renderStudent.bind(_assertThisInitialized(_this));
    return _this;
  }

  return _createClass(AssignAdditionalAdjustments);
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    students: state.Search.students
  };
}

export default connect(mapStateToProps, {
  searchStudents: searchStudents
})(reduxForm({
  form: 'AssignAdditionalAdjustments',
  destroyOnUnmount: true
})(AssignAdditionalAdjustments));